exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-title {\n  font-size: 1rem;\n}\np {\n  margin-bottom: 0.2rem;\n}\nul {\n  margin-bottom: 0.4rem;\n}\nli {\n  font-size: 80%;\n  font-weight: 400;\n}\n.margin-nolabel {\n  margin-top: 34px;\n}\n.vbt-autcomplete-list {\n  overflow-y: auto !important;\n  overflow-x: auto !important;\n}\n.blink_me {\n  -webkit-animation: blinker 2s linear infinite;\n          animation: blinker 2s linear infinite;\n  font-weight: bold;\n}\n@-webkit-keyframes blinker {\n50% {\n    opacity: 0;\n}\n}\n@keyframes blinker {\n50% {\n    opacity: 0;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37077dd0","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/webapp/professional/prescription.vue
// module id = 3902
// module chunks = 30